import { IUserService } from "../Services/userServecesServices";
import { IAnnounce } from "../utils/AnnounceInterfaces";
import { IUser } from "../utils/UserInterfaces";
import { IAnnounceItem } from "./announces";
import { IBaseData } from "./global";

export interface IReservation extends IBaseData {
    dateCheckIn: Date;
    dateCheckOut: Date;
    status: Array<ReservationStatus>;
    travellerChildTotal: number;
    travellerAdultTotal: number;
    announce: IAnnounceItem;
    traveller: IUser;
    attachments: Array<AttachmentInputs>;
    services: string[];
    price: number;
    advancePaymentAmount?: number;
    remainingAmount?: number;
    paymentMethod?: string;
    bookingContext?: {
            bookedByAdmin: boolean;
            adminUserId?: string;
        };
    roomsBooked?: number;
}

export interface IReservationReq extends IBaseData {
    dateCheckIn: Date;
    dateCheckOut: Date;
    status: Array<ReservationStatus>;
    travellerChildTotal: number;
    travellerAdultTotal: number;
    announce: IAnnounce;
    traveller: IUser;
    attachments: Array<AttachmentInputs>;
    services: IUserService[];
    isPaymentPaused: Boolean;
    incrimentationJour: Number;
    price?: number;
    advancePaymentAmount?: number;
    remainingAmount?: number;
    paymentMethod?: string;
    bookingContext?: {
            bookedByAdmin: boolean;
            adminUserId?: string;
        };
    roomsBooked?: number;
    paymentPlan?: {
    isBNPL: boolean;
    dueDate: Date;
    paymentLink: string;
    installments: Array<{
      amount: number;
      dueDate: Date;
      status: 'pending' | 'paid' | 'overdue';
      paymentId?: string;
    }>;
  };
}

export type ReservationStatus = {
    date: Date;
    status: string;
};

export type AttachmentInputs = {
    _id?: string;
    filename: string;
    type: string;
    fileURL?: string;
};

export interface DataReservation {
    _id: string;
    announceId: string;
    property: string;
    travellerNumber: number;
    bookingDate: Date;
    dateCheckIn: Date;
    dateCheckOut: Date;
    requestAge: number;
    status: string;
    updatedAt: Date;
    country: string;
    city: string;
    services: IUserService[];
    isPaymentPaused: Boolean;
    remboursable: String;
    incrimentationJour: Number;
    roomsBooked: Number
}

export function createData(
    _id: string,
    announceId: string,
    property: string,
    travellerNumber: number,
    bookingDate: Date,
    dateCheckIn: Date,
    dateCheckOut: Date,
    requestAge: number,
    status: string,
    updatedAt: Date,
    country: string,
    city: string,
    services: IUserService[],
    isPaymentPaused: Boolean,
    remboursable: String,
    incrimentationJour: Number,
    roomsBooked: number
): DataReservation {
    return {
        _id,
        announceId,
        property,
        travellerNumber,
        bookingDate,
        dateCheckIn,
        dateCheckOut,
        requestAge,
        status,
        updatedAt,
        country,
        city,
        services,
        isPaymentPaused,
        remboursable,
        incrimentationJour,
        roomsBooked,
    };
}

    export interface DataReservationAdmin {
        _id: string;
        property: string;
        address: string; // quartier + city
        traveller: string; // name + count
        dateCheckIn: Date;
        dateCheckOut: Date;
        status: string;
        paymentMethod: string;
        advanceAmount: number;
        remainingAmount: number;
        totalAmount: number;
        serviceFee: number;
        bookingDate: Date;
        roomsBooked: number;
    }

    export function createDataAdmin(
        _id: string,
        property: string,
        address: string,
        traveller: string,
        dateCheckIn: Date,
        dateCheckOut: Date,
        status: string,
        paymentMethod: string,
        advanceAmount: number,
        remainingAmount: number,
        totalAmount: number,
        serviceFee: number,
        bookingDate: Date,
        roomsBooked: number
    ): DataReservationAdmin {
        return {
            _id,
            property,
            address,
            traveller,
            dateCheckIn,
            dateCheckOut,
            status,
            paymentMethod,
            advanceAmount,
            remainingAmount,
            totalAmount,
            serviceFee,
            bookingDate,
            roomsBooked
        };
}

